import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--color-background-header);
`;

export const Title = styled.h1`
  color: var(--color-header-text);
  font-size: var(--font-giant);
  margin-bottom: var(--spacing-small);
`;

export const SubTitle = styled.p`
  color: var(--color-header-text);
  font-size: var(--font-medium);
  margin-bottom: var(--spacing-regular);
  text-align: center;
`;

export const ButtonStyle = {
  padding: '10px 20px !important'
};

